/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PageContainerScroll.vue?vue&type=template&id=1b9c2a98&"
import script from "./PageContainerScroll.vue?vue&type=script&lang=js&"
export * from "./PageContainerScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports